import { Service } from "@/types"
import { atom } from "jotai"

/**
 * TAKEOUT channel **service** from the Open Delivery catalog.
 *
 * Product rule: retirada shares the **DELIVERY menu/catalog**. This atom is
 * only used for TAKEOUT **hours / status / provisioned flag** — never to swap
 * the storefront catalog to `service.menuId` of takeout (even if the portal
 * points takeout at a different menu).
 */
const takeoutServiceAtom = atom<Service | null>(null)

export default takeoutServiceAtom
